class Certificates {
  static initModeToggle() {
    const radios = document.querySelectorAll('.js-mode-trigger');
    if (!radios.length) return;

    const update = () => {
      const checked = document.querySelector('.js-mode-trigger:checked');
      if (!checked) return;
      document.querySelectorAll('.js-mode-section').forEach(el => {
        el.style.display = el.dataset.mode === checked.value ? '' : 'none';
      });
    };

    radios.forEach(r => r.addEventListener('change', update));
    update();
  }

  // pionowe plotno jest wezsze - domyslne pozycje z ukladu poziomego by sie w nim nie zmiescily
  static initLayoutDefaults() {
    const table = document.querySelector('.js-fields-table');
    const radios = document.querySelectorAll('input[name="course_certificate[layout]"]');
    if (!table || !radios.length) return;

    let defaults;
    try {
      defaults = JSON.parse(table.dataset.defaults);
    } catch (e) {
      return;
    }

    const columns = ['offset_bottom', 'offset_left', 'font_size', 'color'];
    const checked = document.querySelector('input[name="course_certificate[layout]"]:checked');
    let previous = checked ? checked.value : null;

    const applyDefaults = (from, to) => {
      Object.keys(to).forEach(field => {
        columns.forEach(column => {
          const input = table.querySelector(`[name="course_certificate[fields_config][${field}][${column}]"]`);
          if (!input) return;
          const previousDefault = (from[field] || {})[column];
          if (String(input.value).toLowerCase() !== String(previousDefault).toLowerCase()) return;

          if (input.jscolor && input.jscolor.fromString) {
            input.jscolor.fromString(to[field][column]);
          } else {
            input.value = to[field][column];
          }
        });
      });
    };

    radios.forEach(radio => radio.addEventListener('change', () => {
      if (!radio.checked || radio.value === previous) return;

      applyDefaults(defaults[previous] || {}, defaults[radio.value] || {});
      previous = radio.value;
    }));
  }

  static fitCustomCert() {
    document.querySelectorAll('.js-custom-cert-scaler').forEach(scaler => {
      const cert = scaler.querySelector('.custom-cert');
      if (!cert) return;
      const fit = () => {
        const baseWidth = parseInt(cert.style.width, 10);
        const baseHeight = parseInt(cert.style.height, 10);
        const scale = Math.min(1, scaler.clientWidth / baseWidth);
        cert.style.transform = `scale(${scale})`;
        scaler.style.height = `${baseHeight * scale}px`;
      };
      fit();
      window.addEventListener('resize', fit);
    });
  }

  static renderCustomCanvas() {
    const cert = document.querySelector('.custom-cert');
    return html2canvas(cert, {
      scale: 2,
      onclone: (clone) => {
        const el = clone.querySelector('.custom-cert');
        if (el) el.style.transform = 'none';
      }
    });
  }

  static downloadCustomJpg(filename) {
    this.renderCustomCanvas().then(canvas => {
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/jpeg', 0.92);
      link.download = `${filename || 'Certyfikat'}.jpg`;
      link.click();
    });
  }

  static downloadCustomPdf(filename) {
    this.renderCustomCanvas().then(canvas => {
      const isVertical = canvas.height > canvas.width;
      const pdf = new jsPDF(isVertical ? 'portrait' : 'landscape', 'mm', 'a4');
      const width = isVertical ? 210 : 297;
      const height = isVertical ? 297 : 210;
      pdf.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', 0, 0, width, height);
      pdf.save(`${filename || 'Certyfikat'}.pdf`);
    });
  }

  static uploadPublicImage() {
    const cert = document.querySelector('.custom-cert');
    if (!cert || !cert.dataset.uploadUrl) return;
    this.renderCustomCanvas().then(canvas => {
      canvas.toBlob(blob => {
        const data = new FormData();
        data.append('file', blob, 'certificate.jpg');
        fetch(cert.dataset.uploadUrl, {
          method: 'POST',
          headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
          body: data
        });
      }, 'image/jpeg', 0.92);
    });
  }

  static initCopyButtons() {
    document.querySelectorAll('.js-copy-button').forEach(btn => {
      btn.addEventListener('click', () => {
        navigator.clipboard.writeText(btn.dataset.copyValue).then(() => {
          const original = btn.textContent;
          btn.textContent = btn.dataset.copiedLabel || original;
          setTimeout(() => { btn.textContent = original; }, 1500);
        });
      });
    });
  }

  static initCustomCertShow() {
    this.fitCustomCert();
    this.initCopyButtons();
    this.uploadPublicImage();
  }

  static downloadCert() {
    const certElement = document.querySelector('.cert');
    const layout = certElement.getAttribute('data-layout');
    const isVertical = layout === 'vertical';

    html2canvas(certElement, {
      scale: 4,
      windowWidth: 1920,
      windowHeight: 1080,
      onclone: (clone) => {
        const content = clone.querySelector('.content');
        if (content) {
          content.style.marginTop = '-10px';
        }
        clone.querySelectorAll('.separator').forEach(el => el.style.margin = '10px 0 0 0');
      }
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/jpeg');
      const pdf = new jsPDF(isVertical ? 'portrait' : 'landscape', 'mm', 'a4');
      const width = isVertical ? 210 : 297;
      const height = isVertical ? 297 : 210;

      pdf.addImage(imgData, 'JPEG', 0, 0, width, height);
      pdf.save('Certyfikat.pdf');
    });
  }
}

export default Certificates;